/**
 * 系统工具类
 * 处理不同系统的兼容性问题
 */

/**
 * 检测是否为iOS系统
 * @returns boolean 是否为iOS系统
 */
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  const iosRegex = /iPad|iPhone|iPod/.test(userAgent);
  
  // 检测iOS 13+的iPad（可能被识别为Mac）
  const isIPadPro = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  
  return iosRegex || isIPadPro;
};

/**
 * 检测是否为Safari浏览器（包括macOS和iOS上的Safari）
 */
export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent;
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && !/Chromium/.test(userAgent);
};

/**
 * 检测是否为移动设备
 * @returns boolean 是否为移动设备
 */
export const isMobile = (): boolean => {
  const userAgent = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};

/**
 * 获取系统信息
 * @returns object 系统信息对象
 */
export const getSystemInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  
  return {
    userAgent,
    platform,
    isIOS: isIOS(),
    isSafari: isSafari(),
    isMobile: isMobile(),
    isAndroid: /Android/i.test(userAgent),
    isWindows: /Win/i.test(platform),
    isMac: /Mac/i.test(platform) && !isIOS(),
    isLinux: /Linux/i.test(platform) && !/Android/i.test(userAgent)
  };
};

/**
 * 兼容所有系统的页面刷新方法
 * iOS系统使用原生JavaScript刷新，其他系统使用router.go(0)
 * @param router Vue Router实例（可选）
 */
export const refreshPage = (router?: any) => {
  const systemInfo = getSystemInfo();
  
  console.log('系统信息:', systemInfo);
  console.log(`当前系统: ${systemInfo.isIOS ? 'iOS' : systemInfo.isAndroid ? 'Android' : systemInfo.isWindows ? 'Windows' : systemInfo.isMac ? 'Mac' : systemInfo.isLinux ? 'Linux' : '未知'}, Safari: ${systemInfo.isSafari}`);
  
  if (systemInfo.isIOS || systemInfo.isSafari) {
    // iOS系统或Safari浏览器使用原生刷新，因为Safari的history.go(0)可能不会触发真正的页面重载
    console.log('检测到iOS/Safari，使用原生JavaScript刷新页面');
    window.location.reload();
  } else if (router && typeof router.go === 'function') {
    console.log('使用Vue Router刷新页面');
    router.go(0);
  } else {
    console.log('备用方案：使用原生JavaScript刷新页面');
    window.location.reload();
  }
};

/**
 * 强制使用原生JavaScript刷新（不依赖router）
 */
export const forceRefresh = () => {
  console.log('强制刷新页面');
  window.location.reload();
};

/**
 * 跳转到指定URL（兼容iOS）
 * @param url 目标URL
 * @param replace 是否替换当前历史记录
 */
export const navigateTo = (url: string, replace: boolean = false) => {
  const systemInfo = getSystemInfo();
  
  if (systemInfo.isIOS) {
    // iOS系统使用原生方法
    if (replace) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  } else {
    // 其他系统可以使用路由或原生方法
    if (replace) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  }
};
